import React from "react";
import {Dialog, DialogContent, DialogTrigger} from "../ui/dialog";
import {K8sPodDetails} from "../K8sInfo/model";
import {ShieldAlert} from "lucide-react";
import {Link} from "react-router-dom";
import {Button} from "../ui/button";
import {DataTable} from "../ui/datatable/datatable";
import {columns, filters} from "./WarningBannerTableColumns";


interface WarningBannerProps {
    type: WarningBannerType
    message: string;
    details?: string;
    pods?: K8sPodDetails[];
}

export enum WarningBannerType {
    trialEndBanner = "trialEndBanner",
    nodeAgentHealth = "nodeAgentHealth",
    demo = "demo"
}

export function WarningBanner(props: WarningBannerProps) {
    if (props.type === WarningBannerType.trialEndBanner || props.type === WarningBannerType.demo) {
        return <div className={"text-sm bg-purple-400/10 border border-purple-400 px-2 py-1"}>{props.message}</div>
    }

    if (props.type === WarningBannerType.nodeAgentHealth) {
        return (
            <Dialog>
                <DialogTrigger>
                    <div
                        className={"flex items-center hover:bg-red-400/20 text-sm bg-red-400/10 border border-red-400 px-2 py-1 hover:text-textlight"}>
                        <ShieldAlert className={"w-5 h-5 text-red-400"}/>
                        <div>{props.message}</div>
                    </div>
                </DialogTrigger>
                <DialogContent className={"w-2/3 text-textmedium overflow-y-auto"}>
                    <div className={"w-full flex items-center gap-2 font-semibold"}>
                        <ShieldAlert className={"text-red-400 w-8 h-8"}/>
                        <div
                            className={"font-semibold text-base"}>{props.pods ? "Some node agents aren't running. This could lead to inconsistent telemetry. Please address the following issues:" : ""}</div>
                    </div>
                    {props.pods && 
                        <DataTable
                            className={"h-[40vh]"}
                            tableTitle={"Node Agent Health Issues"}
                            columns={columns}
                            data={props.pods}
                            textFilteringColumnName={"name"}
                            textFilteringPlaceholder={"Filter pods by name..."}
                            filters={filters}
                            showPagination={true}
                        />
                    }
                    <div className={"text-textdark font-semibold"}>Please contact Metoro team if you need assistance by
                        joining
                        <a href={"https://metoro.io/docs/community-slack"} className={"text-primary"}> Metoro community
                            slack </a>
                        or by emailing us at <a href={"mailto:support@metoro.io"}
                                                className={"text-primary"}>support@metoro.io</a>.
                    </div>
                </DialogContent>
            </Dialog>
        );
    }

    return <></>

}
